// frontend/src/components/forecastgrid/scrollToColumn.js
//
// Scrolls a grid so `colId` is its first visible column — now, if the column
// is shown, or once AG Grid shows it. A page that shows a column through its
// columnDefs asks for the scroll before AG Grid React has handed the grid the
// new columnDefs, which it does in its own effect and may queue.
//
// Returns a cleanup that drops the wait when the column was never shown.

export function scrollToColumnOnceShown(api, colId) {
  const scroll = () => {
    if (!api.getColumn(colId)?.isVisible()) return false;
    api.ensureColumnVisible(colId, 'start');
    return true;
  };
  if (scroll()) return () => {};

  const onDisplayedColumnsChanged = () => {
    if (scroll()) api.removeEventListener('displayedColumnsChanged', onDisplayedColumnsChanged);
  };
  api.addEventListener('displayedColumnsChanged', onDisplayedColumnsChanged);
  return () => {
    if (!api.isDestroyed()) api.removeEventListener('displayedColumnsChanged', onDisplayedColumnsChanged);
  };
}
